import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import BigCard from "../../../general/BigCard";
import styles from "./AgritourismL1.module.css";
import { AgritourismStore } from "./AgritourismStore";
import LeafletMap from "./maps/LeafletMap";

function AgritourismL1({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);

  const setAgroturismoImage = AgritourismStore(
    (state) => state.setAgroMapImage
  );

  const agroturismo = AgritourismStore((state) => state.agroturismoValue);

  const dificuldadeAgroturismo = AgritourismStore(
    (state) => state.dificuldadeAgroturismoValue
  );

  const interesseAgroturismo = AgritourismStore(
    (state) => state.interesseAgroturismoValue
  );

  const formaDeRenda = AgritourismStore((state) => state.formaRendaValue);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [numeroPropriedades, areaMedia] = await Promise.all([
          Api.getNumeroPropriedadesAgroturismo(
            distrito,
            agroturismo,
            interesseAgroturismo,
            dificuldadeAgroturismo,
            formaDeRenda,
          ),
          Api.getAreaMediaAgroturismo(
            distrito,
            agroturismo,
            interesseAgroturismo,
            dificuldadeAgroturismo,
            formaDeRenda,
          ),
        ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    agroturismo,
    dificuldadeAgroturismo,
    interesseAgroturismo,
    formaDeRenda,
  ]);

  return (
    <div className={styles.agritourismL1}>
      <div className={styles.cards}>
        <div className={styles.bigcard}>
          <BigCard name={"Propriedades"} value={numeroPropriedades?.value} />
        </div>
        <div className={styles.bigcard}>
          <BigCard name={"Área Média"} value={areaMedia?.value?.toFixed(2)} />
        </div>
      </div>
      <div className={styles.map}>
        <LeafletMap distrito={distrito} onImageReady={setAgroturismoImage} />
      </div>
    </div>
  );
}

export default AgritourismL1;
